import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes';
import * as actions from './actions';
import { AppConfiguration } from "config";
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";
import { genericGetRequest, genericGetRequest_2 } from 'helpers/sf_backend_helper';

let adminUserDetails;
const header = () => {
    if (!adminUserDetails) {
        adminUserDetails = bsh_getAdminUserDetails();
    }
    return {
        Authorization: adminUserDetails.token
    }
};

const EXECUTION_RESULTS_URL = () => (
    `${AppConfiguration.BACKEND_URL}/api/v1/automation_test_results/execution_results`
);

function* fetchFullBuildExecutionResultsSaga(action) {
    try {
        const response = yield call(genericGetRequest_2, EXECUTION_RESULTS_URL(), { ...action.payload, branch: 'main' }, header());
        yield put(actions.fetchFullBuildExecutionResultsSuccess(response));
    } catch (error) {
        yield put(actions.fetchFullBuildExecutionResultsFailure('Failed to fetch full build execution results'));
    }
}

function* fetchPrBuildExecutionResultsSaga(action) {
    try {
        const response = yield call(genericGetRequest_2, EXECUTION_RESULTS_URL(), { ...action.payload, branch: 'others' }, header());
        yield put(actions.fetchPrBuildExecutionResultsSuccess(response));
    } catch (error) {
        yield put(actions.fetchPrBuildExecutionResultsFailure('Failed to fetch pr build execution results'));
    }
}

function* fetchSuiteResultsSaga(action) {
    try {
        const response = yield call(genericGetRequest, `${AppConfiguration.BACKEND_URL}/api/v1/automation_test_results/suite_results`, { execution_result_id: action.payload }, header());
        yield put(actions.fetchSuiteResultsSuccess(action.payload, response));
    } catch (error) {
        yield put(actions.fetchSuiteResultsFailure('Failed to fetch suite results'));
    }
}

function* fetchCsvReportSaga(action) {
    try {
        const response = yield call(genericGetRequest, `${AppConfiguration.BACKEND_URL}/api/v1/automation_test_results/latency_status`, { semaphore_workflow_id: action.payload }, header());
        yield put(actions.fetchCsvReportSuccess(action.payload, response));
    } catch (error) {
        yield put(actions.fetchCsvReportFailure('Failed to fetch latency status csv reports'));
    }
}

function* AutomationTestsSaga() {
    yield takeLatest(types.FETCH_FULL_BUILD_EXECUTION_RESULTS, fetchFullBuildExecutionResultsSaga);
    yield takeLatest(types.FETCH_PR_BUILD_EXECUTION_RESULTS, fetchPrBuildExecutionResultsSaga);
    yield takeLatest(types.FETCH_SUITE_RESULTS, fetchSuiteResultsSaga);
    yield takeLatest(types.FETCH_CSV_REPORT, fetchCsvReportSaga);
}

export default AutomationTestsSaga;